import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadOrganisationList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );

    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations${params ? `?${params}` : ''}`,
    );
    return result.data;
  },

  loadOrganisationDetail: async (options = {}) => {
    const result = await axios.get(
      `${baseUrl}/customer/companies/${options.organisationId}`,
    );
    return result.data;
  },

  loadPOSiteDetail: async (options = {}) => {
    const result = await axios.get(
      `${baseUrl}/customer/companies/${options.organisationId}/sites/${
        options.companySiteId
      }`,
    );
    return result.data;
  },

  loadCompanySiteList: async (options = {}) => {
    if (options.organisationId) {
      const params = queryString.stringify(
        Object.assign(
          { offset: options.offset, limit: options.limit },
          options.filter,
        ),
      );
      const result = await axios.get(
        `${baseUrl}/customer/mob/organisations/${options.organisationId}/sites${
          params ? `?${params}` : ''
        }`,
      );
      return result.data;
    } else {
      return false;
    }
  },

  validatePatient: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.post(
      `${baseUrl}/scheduler/mob/organisations/${
        options.organisationId
      }/validate${params ? `?${params}` : ''}`,
      { patientId: options.patientId },
    );
    return result.data;
  },
};
